import "./left_sidebar.css"
let icon_arrow = `<svg height="18px" viewBox="0 0 24 24" width="18px" xmlns="http://www.w3.org/2000/svg"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path></svg>`;

export function left_side_bar_size(){
    if (document.body.offsetWidth > 1260) {
        $(".left-sidebar:eq(1)>div").css("width", $(".left-sidebar:eq(1)").width() + "px")
        $(".left-sidebar:eq(1)>div").css("left", $(".left-sidebar:eq(1)").offset().left + "px")
    }
}


$(document).ready(function () {

    $(window).resize(function() {left_side_bar_size()});
     left_side_bar_size()

    function show() {
        $(".toggle_left_sidebar").removeClass("off")
        $(".left-sidebar:eq(1)").removeClass("ds-none")
        left_side_bar_size()
        jqueryts.storage.local.put("left_sidebar", "show")
        document.cookie = "left_sidebar=show; path=/";
    }

    function hide() {
        $(".toggle_left_sidebar").addClass("off")
        $(".left-sidebar:eq(1)").addClass("ds-none")
        // $(".block-main").attr("class", "block-main p-relative col-lg-9 col-12")
        jqueryts.storage.local.put("left_sidebar", "hide")
        document.cookie = "left_sidebar=hide; path=/";
    }

    $(".toggle_left_sidebar").on("click", function () {
        if (!$(this).hasClass("off")) {
            hide()
        } else {
            show()
        }
    })

    if (jqueryts.storage.local.get("left_sidebar"))
        if (jqueryts.storage.local.get("left_sidebar") == "hide") {
            hide()
        } else {
            show();
        }
    function append_toggle(left_bar){
        left_bar.each(function() {
            // console.log($(this))
            if ($(this).hasClass("active")){
                $(this).find(">a").append(`<span class="toggle open">${icon_arrow}</span>`)
            } else {
                $(this).find(">a").append(`<span class="toggle">${icon_arrow}</span>`)
            }

            if ($(this).find("ul").length > 0) {
                $(this).addClass("submenu"); // Добавляем класс has-submenu
            }
        });
    }
    // Проверяем, есть ли у ссылки дочерний ul
    append_toggle($(".left-sidebar:eq(0) > ul  li "))
    append_toggle($(".left-sidebar:eq(1)>div > ul  li "))
    $(".left-sidebar").find("span.toggle").click(function(event) {
        // Получаем ссылку, связанную с псевдоэлементом
        const li = $(this).parent().parent();
        if ($(this).hasClass("open")){
            li.find(">ul").hide()
            $(this).removeClass("open")
        } else {
            li.find(">ul").show()
            $(this).addClass("open")
        }
        return false;
    });

    $(window).scroll(function() {
        left_scroll()
    });
    left_scroll();

    function left_scroll(){
        // return false;
        left_side_bar_size()
        const scrollTop = $(window).scrollTop();
        // фиксация меню
        if (document.body.offsetWidth < 1260) return false;

        if (scrollTop >= $(".header__top").outerHeight() + 50) {
            if ($("#sphinx_page>.block-main").outerHeight() <= $(".left-sidebar:eq(1)>div").outerHeight()) return false;
            $(".left-sidebar:eq(1)>div").addClass("left_bar_fix");
            var blockHeight = $(document).height() - scrollTop-$('.footer').outerHeight()-90;
            $(".left-sidebar:eq(1)>div").css("max-height", blockHeight + "px")
        } else {
            $(".left-sidebar:eq(1)>div").removeClass("left_bar_fix");
            $(".left-sidebar:eq(1)>div").css("max-height", "none")
        }
    }

    $("#version_sphinx").appendTo("#version_tag_block")

});